import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_PUBLIC_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_PUBLIC_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error('Supabase URL ve Anon Key tanımlanmamış!');
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey);

// Database types
export type UserRole = 'admin' | 'editor' | 'viewer';

export interface Settings {
  id: string;
  site_name: string;
  logo_url?: string;
  favicon?: string;
  phone?: string;
  whatsapp?: string;
  email?: string;
  address?: string;
  footer_text?: string;
  social_links?: Record<string, string>;
  created_at: string;
  updated_at: string;
}

export interface Menu {
  id: string;
  title: string;
  url: string;
  parent_id?: string;
  order_index: number;
  is_active: boolean;
  created_at: string;
  updated_at: string;
}

export interface Page {
  id: string;
  title: string;
  slug: string;
  seo_title?: string;
  seo_description?: string;
  seo_keywords?: string;
  is_published: boolean;
  created_at: string;
  updated_at: string;
}

export interface PageBlock {
  id: string;
  page_id: string;
  type: string;
  content: Record<string, any>;
  order_index: number;
  created_at: string;
  updated_at: string;
}

export interface Service {
  id: string;
  title: string;
  slug: string;
  description?: string;
  content?: string;
  image_url?: string;
  icon?: string;
  seo_title?: string;
  seo_description?: string;
  seo_keywords?: string;
  order_index: number;
  is_published: boolean;
  created_at: string;
  updated_at: string;
}

export interface PostCategory {
  id: string;
  name: string;
  slug: string;
  created_at: string;
}

export interface Post {
  id: string;
  title: string;
  slug: string;
  content?: string;
  excerpt?: string;
  cover_url?: string;
  author_id?: string;
  category_id?: string;
  seo_title?: string;
  seo_description?: string;
  seo_keywords?: string;
  is_published: boolean;
  published_at?: string;
  created_at: string;
  updated_at: string;
}

export interface FormSubmission {
  id: string;
  name: string;
  email: string;
  phone?: string;
  message?: string;
  page?: string;
  is_read: boolean;
  created_at: string;
}
